<template>
  <div id="holacon-live-login-screen">
    <div class="login-screen-background">
      <div class="login-screen-panel">
        <div class="login-screen-panel-form">
          <div class="form-header-container">
            <h1>{{ $t("register.register") }}</h1>
            <p>{{ $t("register.desc") }}</p>
          </div>

          <div class="form-inputs-container" @keydown.enter.exact.prevent @keyup.enter.exact="login">
            <div class="custom-input text icon" :class="hasError('firstName')">
              <label>{{ $t("register.firstName") }}</label>
              <el-input placeholder="..." v-model="form.firstName" v-on:input="response.validationErrors.length ? (response.validationErrors = []) : ''"><i slot="prefix" class="fas fa-user"></i></el-input>
              <span class="md-error">{{ errorMessage("firstName") }}</span>
            </div>

            <div class="custom-input text icon" :class="hasError('lastName')">
              <label>{{ $t("register.lastName") }}</label>
              <el-input placeholder="..." v-model="form.lastName" v-on:input="response.validationErrors.length ? (response.validationErrors = []) : ''"><i slot="prefix" class="fas fa-user"></i></el-input>
              <span class="md-error">{{ errorMessage("lastName") }}</span>
            </div>

            <div class="custom-input email icon" :class="hasError('email')">
              <label>{{ $t("register.email") }}</label>
              <el-input placeholder="..." v-model="form.email" v-on:input="response.validationErrors.length ? (response.validationErrors = []) : ''"><i slot="prefix" class="fas fa-envelope"></i></el-input>
              <span class="md-error">{{ errorMessage("email") }}</span>
            </div>

            <div class="custom-input password icon" :class="hasError('password')">
              <label>{{ $t("register.password") }}</label>
              <el-input :type="showpwd != true ? 'password' : 'text'" placeholder="..." v-model="form.password" v-on:input="response.validationErrors.length ? (response.validationErrors = []) : ''">
                <i slot="prefix" class="fas fa-lock"></i>
                <i slot="suffix" class="fa show-pwd" :class="showpwd != true ? 'fa-eye' : 'fa-eye-slash'" @click="showpwd = !showpwd"></i>
              </el-input>
              <span class="md-error">{{ errorMessage("password") }}</span>
            </div>

            <div class="custom-input password icon" :class="hasError('passwordRetry')">
              <label>{{ $t("register.passwordRetry") }}</label>
              <el-input :type="showpwd != true ? 'password' : 'text'" placeholder="..." v-model="form.passwordRetry" v-on:input="response.validationErrors.length ? (response.validationErrors = []) : ''">
                <i slot="prefix" class="fas fa-lock"></i>
                <i slot="suffix" class="fa show-pwd" :class="showpwd != true ? 'fa-eye' : 'fa-eye-slash'" @click="showpwd = !showpwd"></i>
              </el-input>
              <span class="md-error">{{ errorMessage("passwordRetry") }}</span>
            </div>

            

            <div class="custom-checkbox" v-if="settings.whiteLabelSettings.holaconPolicies.length > 0">
              <md-checkbox v-model="form.checkbox" :class="hasError('checkbox')" @change="response.validationErrors.length ? (response.validationErrors = []) : ''"> </md-checkbox>
              <span v-if="$i18n.locale == 'tr'">
                Holacon,
                <template v-for="item in settings.whiteLabelSettings.holaconPolicies"><a target="_blank" @click.stop="openPolicy(item)">{{ item.title }}</a>, </template>
                sözleşmelerini okudum ve kabul ediyorum.
              </span>
              <span v-else>
                I have read and accept to Holacon,
                <template v-for="item in settings.whiteLabelSettings.holaconPolicies"><a target="_blank" @click.stop="openPolicy(item)">{{ item.title }}</a>, </template>
                policies.
              </span>
            </div>


            <div class="custom-checkbox" v-if="settings.whiteLabelSettings.policies.length > 0">
              <md-checkbox v-model="form.checkbox2" :class="hasError('checkbox2')" @change="response.validationErrors.length ? (response.validationErrors = []) : ''"> </md-checkbox>
              <span v-if="$i18n.locale == 'tr'">
                {{ settings.whiteLabelSettings.metaTitle }},
                <template v-for="item in settings.whiteLabelSettings.policies"><a target="_blank" @click.stop="openPolicy(item)">{{ item.title }}</a>, </template>
                sözleşmelerini okudum ve kabul ediyorum.
              </span>
              <span v-else>
                I have read and accept to {{ settings.whiteLabelSettings.metaTitle }},
                <template v-for="item in settings.whiteLabelSettings.policies"><a target="_blank" @click.stop="openPolicy(item)">{{ item.title }}</a>, </template>
                policies.
              </span>
            </div>

            <div class="form-confirm">
              <el-button type="primary" :loading="isLoading" :disabled="isLoading" icon="fas fa-sign-in-alt" @click="login">{{ !isLoading ? (autoRegister ? $t("login.completeRegister") : $t("register.register")) : $t("wait") }}</el-button>
            </div>

            <div class="form-confirm pt-0 visible-xs">
              <button class="outline mono" @click="$router.push({ name: 'login' })">{{ $t("login.login") }}</button>
            </div>
            <div class="form-confirm pt-0 ">
              <button class="outline mono" @click="$router.push({ name: 'home' })">{{ $t("register.backButton") }}</button>
            </div>

            <div class="forgot-pwd-button">
              <router-link :to="{ name: 'forgot-password' }">{{ $t("login.forgot_password") }}</router-link>
            </div>
          </div>

          <div class="download-app visible-xs">
            <h3>{{ $t("login.downloadapp") }}</h3>
            <a target="_blank" :href="$store.state.application.iosLink" v-if="$store.state.application.iosLink != null">
              <img src="/static/apple.png" alt="download" />
            </a>
            <a target="_blank" :href="$store.state.application.androidLink" v-if="$store.state.application.androidLink != null">
              <img src="/static/google.png" alt="download" />
            </a>
          </div>
        </div>

        <div class="login-screen-panel-salute bg-2">
          <div class="login-logo-area" :class="$route.params.slug != 'holacon' ? 'has-whitelabel' : ''">
            <img v-if="$route.params.slug != 'holacon'" :src="$imageus + $store.state.application.image + '?width=200&height=200)'" class="whitelabel-logo" />
            <img v-else src="/static/logo-light.svg" class="logo" />
          </div>

          <div class="salute-container">
            <h1>{{ $t("register.title") }}</h1>
            <p>{{ $t("register.description") }}</p>
          </div>

          <div class="form-confirm hidden-xs">
            <button class="button-light" @click="$router.push({ name: 'login' })">{{ $t("login.login") }}</button>
          </div>

          <div class="download-app hidden-xs">
            <a target="_blank" :href="$store.state.application.iosLink" v-if="$store.state.application.iosLink != null">
              <img src="/static/apple.png" alt="download" />
            </a>
            <a target="_blank" :href="$store.state.application.androidLink" v-if="$store.state.application.androidLink != null">
              <img src="/static/google.png" alt="download" />
            </a>
          </div>
        </div>
      </div>
    </div>
    <el-dialog :visible.sync="policyModal" class="default" :close-on-click-modal="false" append-to-body center destroy-on-close :title="policy.title">
      <div class="custom-modal" v-if="policy.details != null">
        <div class="modal-body no-footer" v-html="policy.details"></div>
      </div>
    </el-dialog>

    <md-snackbar :class="response.hasError ? 'warning' : 'success'" :md-position="'center'" :md-duration="4000" :md-active.sync="response.hasError" md-persistent>
      <i :class="response.hasError ? 'fa-exclamation-triangle' : 'fa-check'"></i><span>{{ response.message }}</span>
    </md-snackbar>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "Login",
  data() {
    return {
      policyModal: false,
      policy: {},
      form: {
        email: this.$route.query.email || null,
        password: this.$route.query.password || null,
        firstName: this.$route.query.firstName || null,
        lastName: this.$route.query.lastName || null,
        passwordRetry: this.$route.query.password || null,
        checkbox: false,
        checkbox2: false
      },
      isLoading: false,
      isError: false,
      showpwd: false,
      response: {
        hasError: false,
        message: null,
        validationErrors: []
      },
      activationCode: this.$route.query.activationCode || null,
      autoRegister: false,
      policies: [],
      settings: {
        whiteLabelSettings: {  
          policies: [],
          holaconPolicies: []
        }
      }
    };
  },
  async created() {

    var settingsResponse = await axios.post("definition/getApplicationsettings", {
      id: this.currentApplication.id
    });
    this.settings = settingsResponse.data.data;

    var res = await this.$store.dispatch("getApplicationPolicies", this.currentApplication.id);
    this.policies = res.data.data.items;
    localStorage.setItem("policy", JSON.stringify(res.data.data.items));
    if (this.form.email != null && this.form.password != null && this.form.passwordRetry != null && this.form.firstName != null && this.form.lastName != null) {
      this.autoRegister = true;
    }

    const urlParams = new URLSearchParams(window.location.search);
    const myParam = urlParams.get('openPolicy');
    if(myParam != null)
    {
      let found = this.settings.whiteLabelSettings.policies.find(x => x.slug == myParam)
      if(found != null)
      {
        this.openPolicy(found)
      }
      else
      {
        let found = this.settings.whiteLabelSettings.holaconPolicies.find(x => x.slug == myParam)
        if(found != null)
        {
          this.openPolicy(found)
        }
      }
      
    }

  },
  computed: {
    currentApplication() {
      return this.$store.getters.getApplication;
    },
  },
  methods: {
    openPolicy(item) {
      this.policy = item;
      if (this.policy == null) {
        this.$message.info("Sözleşme bulunamadı");
        return;
      }
      this.policyModal = true;
    },
    async login() {
      this.isLoading = true;

      if (this.settings.whiteLabelSettings.holaconPolicies.length > 0 && this.form.checkbox == false) {
        this.$message.warning(this.$i18n.t("pleaseCheckPolicy"));
        this.response.validationErrors = [{ key: "checkbox", value: this.$i18n.t("pleaseControlArea") }];
        setTimeout(() => {
          this.isLoading = false;
        }, 500);
        return;
      }

      if (this.settings.whiteLabelSettings.policies.length > 0 && this.form.checkbox2 == false) {
        this.$message.warning(this.$i18n.t("pleaseCheckPolicy"));
        this.response.validationErrors = [{ key: "checkbox2", value: this.$i18n.t("pleaseControlArea") }];
        setTimeout(() => {
          this.isLoading = false;
        }, 500);
        return;
      }


      try {
        var response = await axios.post("login/signUp", this.form);
        this.response.validationErrors = response.data.validationErrors;

        if (response.data.hasError == false) {
          this.$store.commit("setToken", response.data.data.token);
          var userResponse = await axios.post("account/get");
          this.$store.commit("setUser", userResponse.data.data.user);
          this.$store.commit("setNotify", userResponse.data.data);
          localStorage.setItem("token", response.data.data.token);
          this.$router.push({
            name: "home",
            params: { slug: this.$route.params.slug },
            query: this.$route.query.activationCode != undefined ? { activationCode: this.activationCode.replace("-", "") } : {}
          });

          this.$message.success(response.data.message);
        } else {
          this.$message.error(response.data.message);
        }
      } catch (err) {
        this.$message.error(err.message);
      }

      setTimeout(() => {
        this.isLoading = false;
      }, 500);
    },
    hasError(key) {
      if (this.response.validationErrors.some(k => k.key == key)) {
        return "md-invalid";
      } else {
        return "";
      }
    },
    errorMessage(key) {
      if (this.response.validationErrors.some(k => k.key == key)) {
        return this.response.validationErrors.find(k => k.key == key).value;
      } else {
        return "";
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Register.vue